/* eslint-disable react/no-danger,no-template-curly-in-string */
import React, {Component} from 'react';
import postscribe from 'postscribe';
import Page from './BookviewerFeed.html';
import './BookviewerFeed.scss';

class BookviewerFeed extends Component {
    state = {
        scriptsLoaded: false
    };

    componentDidMount() {
        this.handleLoading();
    }

    handleLoading = () => {
        const element = document.getElementById('bookviewerFeedApp');

        if (element && !this.state.scriptsLoaded) {
            // Load Scripts
            postscribe('#bookviewerFeedApp', '<script src="https://cdnjs.cloudflare.com/ajax/libs/socket.io/2.1.1/socket.io.js"></script>');
            postscribe('#bookviewerFeedApp', '<script src="https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.11/lodash.js"></script>');
            postscribe('#bookviewerFeedApp', '<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.22.2/moment.min.js"></script>');
            postscribe('#bookviewerFeedApp', '<script src="https://cdn.jsdelivr.net/npm/moment-timezone@0.5.23/builds/moment-timezone.min.js"></script>');
            postscribe('#bookviewerFeedApp', '<script src="https://cdn.jsdelivr.net/npm/vue@2.5.17/dist/vue.min.js"></script>');
            postscribe('#bookviewerFeedApp', '<script>\n' +
                '\n' +
                '    /** For IE **/\n' +
                '    Math.trunc = Math.trunc || function(x) {\n' +
                '        if (isNaN(x)) {\n' +
                '            return NaN;\n' +
                '        }\n' +
                '        if (x > 0) {\n' +
                '            return Math.floor(x);\n' +
                '        }\n' +
                '        return Math.ceil(x);\n' +
                '    };\n' +
                '    if (typeof Object.assign != \'function\') {\n' +
                '        Object.assign = function(target) {\n' +
                '            \'use strict\';\n' +
                '            if (target == null) {\n' +
                '                throw new TypeError(\'Cannot convert undefined or null to object\');\n' +
                '            }\n' +
                '\n' +
                '            target = Object(target);\n' +
                '            for (var index = 1; index < arguments.length; index++) {\n' +
                '                var source = arguments[index];\n' +
                '                if (source != null) {\n' +
                '                    for (var key in source) {\n' +
                '                        if (Object.prototype.hasOwnProperty.call(source, key)) {\n' +
                '                            target[key] = source[key];\n' +
                '                        }\n' +
                '                    }\n' +
                '                }\n' +
                '            }\n' +
                '            return target;\n' +
                '        };\n' +
                '    }\n' +
                '    var mdeHash = {};\n' +
                '    moment.tz.add(\'America/New_York|EST EDT|50 40|01010101010101010101010|1BQT0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6\');\n' +
                '    var app = new Vue({\n' +
                '        el: \'#app\',\n' +
                '        data: {\n' +
                '            fxSocket: null,\n' +
                '            tableData: [],\n' +
                '            hashData: {},\n' +
                '            rawData: null,\n' +
                '            filter: null,\n' +
                '            lastUpdated: null,\n' +
                '            filterValues: {\n' +
                '                otr: \'OTR\',\n' +
                '                old: \'OLD\',\n' +
                '                spread: \'SPREAD\',\n' +
                '                otrTest: \'OTR-TEST\',\n' +
                '                spreadTest: \'SPREAD-TEST\',\n' +
                '                tom: \'TOP-OF-MARKET\'\n' +
                '            },\n' +
                '            MDEntryTypes: {\n' +
                '                bid: 0,\n' +
                '                offer: 1\n' +
                '            },\n' +
                '            mde:{},\n' +
                '            mdeTable: {},\n' +
                '            lastOtrForOld: {},\n' +
                '            refreshInterval: null,\n' +
                '            showOrders: 5,\n' +
                '            securityListSpreads: []\n' +
                '        },\n' +
                '        watch: {\n' +
                '            filter: function () {\n' +
                '                if (this.rawData) {\n' +
                '                    this.renderData(this.rawData);\n' +
                '                }\n' +
                '                if (this.mdeTable) {\n' +
                '                    this.renderDataTest(this.mdeTable);\n' +
                '                }\n' +
                '            }\n' +
                '        },\n' +
                '        methods: {\n' +
                '            combineBidOffers: function(bids, offers) {\n' +
                '                let result = [];\n' +
                '                bids = bids.sort(function (a,b) {\n' +
                '                    if (a.MDEntryPx > b.MDEntryPx)\n' +
                '                        return -1;\n' +
                '                    if (a.MDEntryPx < b.MDEntryPx)\n' +
                '                        return 1;\n' +
                '                    return 0;\n' +
                '                });\n' +
                '\n' +
                '                offers = offers.sort(function (a,b) {\n' +
                '                    if (a.MDEntryPx < b.MDEntryPx)\n' +
                '                        return -1;\n' +
                '                    if (a.MDEntryPx > b.MDEntryPx)\n' +
                '                        return 1;\n' +
                '                    return 0;\n' +
                '                });\n' +
                '\n' +
                '                try {\n' +
                '                    for (let i = 0; i < 5; i++) {\n' +
                '                        result.push({\n' +
                '                            bidQuantity: bids[i][\'MDEntrySize\'],\n' +
                '                            bidPrice: bids[i][\'MDEntryPx\'],\n' +
                '                            offerPrice: offers[i][\'MDEntryPx\'],\n' +
                '                            offerQuantity: offers[i][\'MDEntrySize\'],\n' +
                '                        })\n' +
                '                    }\n' +
                '                } catch (e) {\n' +
                '                    console.log(e);\n' +
                '                    return result;\n' +
                '                }\n' +
                '\n' +
                '\n' +
                '                return result;\n' +
                '            },\n' +
                '            /**\n' +
                '             * Show data in tables\n' +
                '             * @param {array} rawData\n' +
                '             * */\n' +
                '            renderData: function (rawData) {\n' +
                '                //debugger\n' +
                '                /** Depends on filter value, show data */\n' +
                '                switch (this.filter) {\n' +
                '                    case this.filterValues.otr:\n' +
                '                        for (let i in rawData) {\n' +
                '                            if (rawData.hasOwnProperty(i)) {\n' +
                '                                if (this.getItemType(i) === this.filterValues.otr) {\n' +
                '                                    //todo Sort array data\n' +
                '                                    rawData[i] = rawData[i].filter(function (val) {\n' +
                '                                        //debugger\n' +
                '                                        let res =  val[\'Symbol\'] !== \'1M\'\n' +
                '                                            && val[\'Symbol\'] !== \'3M\'\n' +
                '                                            && val[\'Symbol\'] !== \'6M\'\n' +
                '                                            && val[\'Symbol\'] !== \'1Y\';\n' +
                '                                        return res;\n' +
                '                                    });\n' +
                '\n' +
                '                                    rawData[i] = rawData[i].sort(function (a,b) {\n' +
                '                                        let periodA = a[\'Symbol\'].match(/\\d+/)[0];\n' +
                '                                        let periodB = b[\'Symbol\'].match(/\\d+/)[0];\n' +
                '                                        return periodA - periodB;\n' +
                '                                    });\n' +
                '\n' +
                '                                    rawData[i].forEach(function(val) {\n' +
                '                                        if (val.bids && val.offers) {\n' +
                '                                            val.orders = this.combineBidOffers(val.bids, val.offers)\n' +
                '                                        }\n' +
                '                                    });\n' +
                '\n' +
                '\n' +
                '                                    this.tableData = rawData[i];\n' +
                '\n' +
                '                                    this.addToHash(this.tableData);\n' +
                '                                    //this.watchForSavedData(this.tableData, this. );\n' +
                '                                }\n' +
                '                            }\n' +
                '                        }\n' +
                '                        break;\n' +
                '                    case this.filterValues.old:\n' +
                '                        let oldDataResult = [];\n' +
                '                        for (let i in rawData) {\n' +
                '                            if (rawData.hasOwnProperty(i)) {\n' +
                '                                if (this.getItemType(i) === this.filterValues.old) {\n' +
                '                                    oldDataResult = oldDataResult.concat(rawData[i]);\n' +
                '                                }\n' +
                '                            }\n' +
                '                        }\n' +
                '                        this.addToHash(oldDataResult);\n' +
                '                        /** Process off-the-run-data group it by symb + symbSuffix */\n' +
                '                        oldDataResult = this.groupOffTheRunData(oldDataResult);\n' +
                '                        this.tableData = oldDataResult;\n' +
                '\n' +
                '                        //this.watchForSavedData(this.tableData, this.filter);\n' +
                '                        break;\n' +
                '                    case this.filterValues.spread:\n' +
                '                        let spreadDataResult = [];\n' +
                '                        for (let i in rawData) {\n' +
                '                            if (rawData.hasOwnProperty(i)) {\n' +
                '                                if (this.getItemType(i) === this.filterValues.spread) {\n' +
                '                                    spreadDataResult = spreadDataResult.concat(rawData[i]);\n' +
                '                                }\n' +
                '                            }\n' +
                '                        }\n' +
                '                        spreadDataResult = this.filterAndSortSpread(spreadDataResult);\n' +
                '\n' +
                '                        this.addToHash(spreadDataResult);\n' +
                '                        this.tableData = this.groupSpreadData(spreadDataResult);\n' +
                '                        break;\n' +
                '                    case this.filterValues.spreadTest:\n' +
                '                        let spreadDataResultTest = [];\n' +
                '                        for (let i in rawData) {\n' +
                '                            if (rawData.hasOwnProperty(i)) {\n' +
                '                                if (this.getItemType(i) === this.filterValues.spread) {\n' +
                '                                    spreadDataResultTest = spreadDataResultTest.concat(rawData[i]);\n' +
                '                                }\n' +
                '                            }\n' +
                '                        }\n' +
                '                        spreadDataResultTest = this.filterAndSortSpread(spreadDataResultTest);\n' +
                '\n' +
                '                        this.addToHash(spreadDataResultTest);\n' +
                '\n' +
                '                        this.tableData = this.groupSpreadDataTest(spreadDataResultTest);\n' +
                '                        break;\n' +
                '                    default:\n' +
                '                        break;\n' +
                '                }\n' +
                '            },\n' +
                '            renderDataTest: function (data, itemType) {\n' +
                '                /** Case if we get Incremental refresh, skip update if we have not current filter */\n' +
                '                if (itemType && this.filter !== itemType) {\n' +
                '                    return\n' +
                '                }\n' +
                '\n' +
                '                switch (this.filter) {\n' +
                '                    case this.filterValues.otr:\n' +
                '                        this.renderOtrTest(data);\n' +
                '                        break;\n' +
                '                    case this.filterValues.old:\n' +
                '                        this.renderOldTest(data);\n' +
                '                        break;\n' +
                '                    case this.filterValues.spread:\n' +
                '                        this.renderSpreadTest(data);\n' +
                '                        break;\n' +
                '                    case this.filterValues.tom:\n' +
                '                        this.renderTopOfMarket(data);\n' +
                '                        break;\n' +
                '                    default:\n' +
                '                        break;\n' +
                '                }\n' +
                '            },\n' +
                '\n' +
                '            renderOtrTest: function(data) {\n' +
                '                if (!data) {\n' +
                '                    return null\n' +
                '                }\n' +
                '                this.tableData = this.fillOtrInitialData();\n' +
                '                let objKeys = Object.keys(data);\n' +
                '                let self = this;\n' +
                '\n' +
                '                objKeys = objKeys.filter(function (val) {\n' +
                '                    let keys = val.split(\'_\');\n' +
                '                    if (!keys[1]) {\n' +
                '                        return false;\n' +
                '                    }\n' +
                '                    //debugger\n' +
                '                    if (keys[1] !== self.filterValues.otr) {\n' +
                '                        return false\n' +
                '                    }\n' +
                '                    return keys[1] !== \'1M\'\n' +
                '                        || keys[1] !== \'3M\'\n' +
                '                        || keys[1] !== \'6M\'\n' +
                '                        || keys[1] !== \'1Y\';\n' +
                '                }).sort(function (a,b) {\n' +
                '                    let periodA = a.match(/\\d+/)[0];\n' +
                '                    let periodB = b.match(/\\d+/)[0];\n' +
                '                    return periodA - periodB;\n' +
                '                });\n' +
                '\n' +
                '                objKeys.forEach(function (val) {\n' +
                '                    let o = { period: val };\n' +
                '                    let sortedEntries = data[val];\n' +
                '\n' +
                '                    /** Last  otr for old table*/\n' +
                '                    //debugger\n' +
                '                    Vue.set(self.lastOtrForOld, self.getTitleFromOLDKey(val), { bid: sortedEntries.bids[0], offer: sortedEntries.offers[0] });\n' +
                '                    self.tableData.forEach(function (td, key, arr) {\n' +
                '                        let keys = val.split(\'_\');\n' +
                '                        if (td.period === keys[0] + \'_\' + keys[1]) {\n' +
                '                            arr[key].refreshes = sortedEntries;\n' +
                '                        }\n' +
                '                    })\n' +
                '                });\n' +
                '            },\n' +
                '            renderOldTest: function (data) {\n' +
                '                if (!data) {\n' +
                '                    return null\n' +
                '                }\n' +
                '                this.tableData = this.fillOldInitialData();\n' +
                '                let objKeys = Object.keys(data);\n' +
                '                let oldKeys = [\'OLD\', \'OLD1\', \'OLD2\'];\n' +
                '                let self = this;\n' +
                '\n' +
                '                objKeys = objKeys.filter(function (val) {\n' +
                '                    let keys = val.split(\'_\');\n' +
                '                    if (!keys[1]) {\n' +
                '                        return false;\n' +
                '                    }\n' +
                '\n' +
                '                    return oldKeys.indexOf(keys[1]) > -1;\n' +
                '                });\n' +
                '\n' +
                '                objKeys = objKeys.sort(function (a,b) {\n' +
                '                    let periodA = a.match(/\\d+/)[0];\n' +
                '                    let periodB = b.match(/\\d+/)[0];\n' +
                '                    return periodA - periodB;\n' +
                '                });\n' +
                '                objKeys.forEach(function (val) {\n' +
                '                    let keys = val.split(\'_\');\n' +
                '\n' +
                '                    self.tableData.forEach(function (td) {\n' +
                '                        if (td.period === keys[0] + \'_OLD\') {\n' +
                '                            td.refreshes.orders.forEach(function (order, key, arr) {\n' +
                '                                if (order.SymbolSfx === keys[1]) {\n' +
                '                                    Vue.set(arr, key, data[val].orders[0]);\n' +
                '                                }\n' +
                '                            })\n' +
                '                        }\n' +
                '                    });\n' +
                '                });\n' +
                '            },\n' +
                '            renderSpreadTest: function (data) {\n' +
                '                if (!data) {\n' +
                '                    return null\n' +
                '                }\n' +
                '                let spreadsData = [];\n' +
                '                let objKeys = Object.keys(data);\n' +
                '                let self = this;\n' +
                '                objKeys = objKeys.filter(function (val) {\n' +
                '                    return self.getItemType(val) === self.filterValues.spread;\n' +
                '                }).sort(function (a,b) {\n' +
                '                    let periodA = a.match(/\\d+/)[0] + \'\' + (a.match(/\\d+/g)[1] / 100);\n' +
                '                    let periodB = b.match(/\\d+/)[0] + \'\' + (b.match(/\\d+/g)[1] / 100);\n' +
                '                    return periodA - periodB;\n' +
                '                });\n' +
                '                objKeys.forEach(function (val) {\n' +
                '                    const spreadSymbol = val.split(\'_\')[0];\n' +
                '                    let spread = { title: self.getTitleFromSpreadKey(val) };\n' +
                '                    let sortedEntries = data[val];\n' +
                '                    if (sortedEntries.orders && sortedEntries.orders.length) {\n' +
                '                        let latestOrder = sortedEntries.orders[0];\n' +
                '                        spread.anchorLegWeight = self.getLegWeight(spreadSymbol, 0);\n' +
                '                        spread.calculatedLegWeight = self.getLegWeight(spreadSymbol, 1);\n' +
                '                        spread.bidQuantity = latestOrder.bidQuantity;\n' +
                '                        spread.bidPrice = latestOrder.bidPrice;\n' +
                '                        spread.offerQuantity = latestOrder.offerQuantity;\n' +
                '                        spread.offerPrice = latestOrder.offerPrice;\n' +
                '                    }\n' +
                '                    spreadsData.push(spread);\n' +
                '                });\n' +
                '                this.tableData = spreadsData;\n' +
                '            },\n' +
                '            renderTopOfMarket: function(data){\n' +
                '                if (!data) {\n' +
                '                    return null\n' +
                '                }\n' +
                '                this.tableData = this.fillOtrInitialData();\n' +
                '                this.tableData.push({\n' +
                '                    period: \'30Y_OLD\',\n' +
                '                    refreshes: {\n' +
                '                        orders: []\n' +
                '                    }\n' +
                '                });\n' +
                '                let objKeys = Object.keys(data);\n' +
                '                let self = this;\n' +
                '\n' +
                '                objKeys = objKeys.filter(function (val) {\n' +
                '                    let keys = val.split(\'_\');\n' +
                '                    if (!keys[1]) {\n' +
                '                        return false;\n' +
                '                    }\n' +
                '\n' +
                '                    if (keys[1] !== self.filterValues.otr && (keys[0] !== \'30Y\' && keys[1] !== self.filterValues.old)) {\n' +
                '                        return false\n' +
                '                    }\n' +
                '                    return keys[1] !== \'1M\'\n' +
                '                        || keys[1] !== \'3M\'\n' +
                '                        || keys[1] !== \'6M\'\n' +
                '                        || keys[1] !== \'1Y\';\n' +
                '                }).sort(function (a,b) {\n' +
                '                    let periodA = a.match(/\\d+/)[0];\n' +
                '                    let periodB = b.match(/\\d+/)[0];\n' +
                '                    return (+periodA) - (+periodB);\n' +
                '                });\n' +
                '\n' +
                '                objKeys.forEach(function (val) {\n' +
                '                    let sortedEntries = data[val];\n' +
                '\n' +
                '                    /** Last  otr for old table*/\n' +
                '                    self.tableData.forEach(function (td, key, arr) {\n' +
                '                        let keys = val.split(\'_\');\n' +
                '                        if (td.period === keys[0] + \'_\' + keys[1]) {\n' +
                '                            arr[key].refresh = sortedEntries.orders[0];\n' +
                '                        }\n' +
                '                    })\n' +
                '                });\n' +
                '            },\n' +
                '            /**\n' +
                '             *\n' +
                '             * @param spreadSymbol\n' +
                '             * @param {number} type\n' +
                '             * @returns {*}\n' +
                '             */\n' +
                '            getLegWeight: function(spreadSymbol, type) {\n' +
                '                if (!type && type !== 0 && type !== 1) {\n' +
                '                    return null\n' +
                '                }\n' +
                '                const LegSecurity = this.securityListSpreads.find((val) => {\n' +
                '                    return val.Symbol === spreadSymbol;\n' +
                '                });\n' +
                '                if (LegSecurity) {\n' +
                '                    if (LegSecurity.legs && LegSecurity.legs.length) {\n' +
                '                        return LegSecurity.legs[type].LegRatioQty / 1000000\n' +
                '                    }\n' +
                '                }\n' +
                '                return null\n' +
                '            },\n' +
                '            /**\n' +
                '             * Give P or G value\n' +
                '             * @param spread\n' +
                '             * @param type {string} type\n' +
                '             */\n' +
                '            processSpreadPrice: function(spread, type) {\n' +
                '                var diff;\n' +
                '                var result;\n' +
                '                if (type === \'bid\') {\n' +
                '                    diff = Math.abs(spread.bidPrice) - Math.abs(spread.offerPrice);\n' +
                '                    result = diff > 0 ? \'P\' : \'G\';\n' +
                '                    return result + \' \' + Math.abs(spread.bidPrice);\n' +
                '                } else if(type === \'offer\') {\n' +
                '                    diff = Math.abs(spread.offerPrice) - Math.abs(spread.bidPrice);\n' +
                '                    result = diff > 0 ? \'P\' : \'G\';\n' +
                '                    return result + \' \' + Math.abs(spread.offerPrice);\n' +
                '                }\n' +
                '            },\n' +
                '            fillOldInitialData: function() {\n' +
                '                return [\'2Y\', \'3Y\', \'7Y\', \'5Y\', \'10Y\', \'30Y\'].map(function (period) {\n' +
                '                    let data = { period: period + \'_OLD\' };\n' +
                '                    data.refreshes = {\n' +
                '                        orders: [\n' +
                '                            {\n' +
                '                                SymbolSfx: \'OLD\'\n' +
                '                            },\n' +
                '                            {\n' +
                '                                SymbolSfx: \'OLD1\'\n' +
                '                            },\n' +
                '                            {\n' +
                '                                SymbolSfx: \'OLD2\'\n' +
                '                            }\n' +
                '                        ]\n' +
                '                    };\n' +
                '                    return data;\n' +
                '                });\n' +
                '            },\n' +
                '            fillOtrInitialData: function() {\n' +
                '                return [\'2Y\', \'3Y\', \'5Y\', \'7Y\', \'10Y\', \'30Y\'].map(function (period) {\n' +
                '                    return {\n' +
                '                        period: period + \'_OTR\',\n' +
                '                        refreshes: {\n' +
                '                            orders: []\n' +
                '                        }\n' +
                '                    }\n' +
                '                });\n' +
                '            },\n' +
                '            /**\n' +
                '             * Adding data to hash table for more effective search\n' +
                '             * @param {array} data\n' +
                '             *\n' +
                '             * */\n' +
                '            addToHash: function(data) {\n' +
                '                if (!data || !data.length) {\n' +
                '                    return null;\n' +
                '                }\n' +
                '                data.forEach(function (val) {\n' +
                '                    try{\n' +
                '                        let hashKey = val[\'Symbol\'] + \'_\' + val[\'SymbolSfx\'] + \'_\' + val[\'Product\'] + \'_\' + val[\'SecurityType\'];\n' +
                '                        this.hashData[hashKey] = val;\n' +
                '                    }catch (e) {\n' +
                '                        console.log(e);\n' +
                '                    }\n' +
                '                });\n' +
                '            },\n' +
                '            sortTablesByType: function() {\n' +
                '                let that = this;\n' +
                '                for (let type in that.mde) {\n' +
                '                    if (that.mde.hasOwnProperty(type)) {\n' +
                '                        for (let mdreqId in that.mde[type]) {\n' +
                '                            if (that.mde[type].hasOwnProperty(mdreqId)) {\n' +
                '                                if (!that.mdeTable[mdreqId]) {\n' +
                '                                    that.mdeTable[mdreqId] = {}\n' +
                '                                }\n' +
                '\n' +
                '                                /**\n' +
                '                                 * Turn values to number for sorting\n' +
                '                                 */\n' +
                '                                let tableDataPart = that.mde[type][mdreqId].map(function (v) {\n' +
                '                                    v[\'MDEntryID\'] = Number(v[\'MDEntryID\']);\n' +
                '                                    return v;\n' +
                '                                });\n' +
                '\n' +
                '                                that.mdeTable[mdreqId][type] = _.orderBy(tableDataPart, [\'MDEntryPx\', \'createdAt\', \'MDEntryID\'], [(type === \'bids\' ? \'desc\' : \'asc\'), \'asc\', \'desc\'])\n' +
                '                                    .slice(0, that.showOrders);\n' +
                '\n' +
                '                                /** Last bid OTR for rendering in OLD */\n' +
                '                                let keys = mdreqId.split(\'_\');\n' +
                '                                let lastOtr;\n' +
                '                                if (keys[1] === \'OTR\') {\n' +
                '                                    lastOtr = Object.assign({}, that.lastOtrForOld[that.getTitleFromOLDKey(mdreqId)]);\n' +
                '                                    if (type === \'bids\') {\n' +
                '                                        lastOtr.bid = that.mdeTable[mdreqId][type][0];\n' +
                '                                        Vue.set(that.lastOtrForOld, that.getTitleFromOLDKey(mdreqId), lastOtr);\n' +
                '                                    } else {\n' +
                '                                        lastOtr.offer = that.mdeTable[mdreqId][type][0];\n' +
                '                                        Vue.set(that.lastOtrForOld, that.getTitleFromOLDKey(mdreqId), lastOtr);\n' +
                '                                    }\n' +
                '                                }\n' +
                '                            }\n' +
                '                        }\n' +
                '                    }\n' +
                '                }\n' +
                '            },\n' +
                '\n' +
                '            combineTablesForOrders: function() {\n' +
                '                let that = this;\n' +
                '                for (let mdreqId in that.mdeTable) {\n' +
                '                    if (that.mdeTable.hasOwnProperty(mdreqId)) {\n' +
                '                        that.mdeTable[mdreqId][\'orders\'] = [];\n' +
                '                        for (let i = 0; i < that.showOrders; i++) {\n' +
                '                            let instrument = that.mdeTable[mdreqId];\n' +
                '                            try {\n' +
                '                                let completedOrder = {};\n' +
                '                                if (instrument[\'bids\'] && instrument[\'bids\'][i]) {\n' +
                '                                    completedOrder.CouponRate = instrument[\'bids\'][i][\'CouponRate\'];\n' +
                '                                    completedOrder.MaturityDate = instrument[\'bids\'][i][\'MaturityDate\'];\n' +
                '                                    completedOrder.bidCreatedAt = instrument[\'bids\'][i][\'createdAt\'];\n' +
                '                                    completedOrder.bidPrice = instrument[\'bids\'][i][\'MDEntryPx\'];\n' +
                '                                    completedOrder.bidQuantity = instrument[\'bids\'][i][\'MDEntrySize\'];\n' +
                '                                    completedOrder.bidID = instrument[\'bids\'][i][\'MDEntryID\'];\n' +
                '                                }\n' +
                '\n' +
                '                                if (instrument[\'offers\'] && instrument[\'offers\'][i]) {\n' +
                '                                    completedOrder.CouponRate = instrument[\'offers\'][i][\'CouponRate\'];\n' +
                '                                    completedOrder.MaturityDate = instrument[\'offers\'][i][\'MaturityDate\'];\n' +
                '                                    completedOrder.offerPrice = instrument[\'offers\'][i][\'MDEntryPx\'];\n' +
                '                                    completedOrder.offerQuantity = instrument[\'offers\'][i][\'MDEntrySize\'];\n' +
                '                                    completedOrder.offerCreatedAt = instrument[\'offers\'][i][\'createdAt\'];\n' +
                '                                    completedOrder.offerID = instrument[\'offers\'][i][\'MDEntryID\'];\n' +
                '                                }\n' +
                '                                instrument[\'orders\'].push(completedOrder);\n' +
                '                            } catch (e) {\n' +
                '                                console.log(\'Cannot make order\' + e.message);\n' +
                '                            }\n' +
                '                        }\n' +
                '                    }\n' +
                '                }\n' +
                '            },\n' +
                '            /**\n' +
                '             * Socket callbacks on events\n' +
                '             * */\n' +
                '            socketEvents: function() {\n' +
                '                let that = this;\n' +
                '\n' +
                '                this.fxSocket.on(\'data_current_state\', function(data) {\n' +
                '                    if (!data || typeof data !== \'object\' || !Object.keys(data).length) {\n' +
                '                        return\n' +
                '                    }\n' +
                '                    mdeHash = {};\n' +
                '                    that.mde = data;\n' +
                '                    that.mdeTable = {};\n' +
                '\n' +
                '                    /** Adding data to hash */\n' +
                '                    for (let i in data) {\n' +
                '                        if (data.hasOwnProperty(i)) {\n' +
                '                            for (let period in data[i]) {\n' +
                '                                if (data[i].hasOwnProperty(period)) {\n' +
                '                                    let itt = data[i][period];\n' +
                '                                    if (itt && itt.length) {\n' +
                '                                        itt.forEach(function(val) {\n' +
                '                                            mdeHash[i + \'_\' + period + \'_\' + val[\'MDEntryID\']] = val\n' +
                '                                        })\n' +
                '                                    }\n' +
                '                                }\n' +
                '                            }\n' +
                '                        }\n' +
                '                    }\n' +
                '\n' +
                '                    that.sortTablesByType();\n' +
                '                    that.combineTablesForOrders();\n' +
                '                    that.renderDataTest(that.mdeTable);\n' +
                '                });\n' +
                '\n' +
                '                this.fxSocket.on(\'data_item\', function(data) {\n' +
                '                    var actions = data.actions;\n' +
                '                    var lastUpdateTime = data.lastUpdateTime;\n' +
                '\n' +
                '                    actions.forEach(function (action) {\n' +
                '                        action[\'MDEntries\'].forEach(function(entry) {\n' +
                '                            var entryType = entry[\'MDEntryType\'] === \'0\' ? \'bids\' : \'offers\';\n' +
                '                            var entryAction = entry[\'MDUpdateAction\'] === \'0\' ? \'new\' : \'delete\';\n' +
                '                            var instrument;\n' +
                '                            if (!entry[\'createdAt\']) {\n' +
                '                                entry[\'createdAt\'] = action[\'SendingTime\'];\n' +
                '                            }\n' +
                '\n' +
                '                            if (!entry[\'CouponRate\']) {\n' +
                '                                entry[\'CouponRate\'] = action[\'CouponRate\'];\n' +
                '                            }\n' +
                '\n' +
                '                            if (!entry[\'MaturityDate\']) {\n' +
                '                                entry[\'MaturityDate\'] = action[\'MaturityDate\'];\n' +
                '                            }\n' +
                '\n' +
                '\n' +
                '                            switch (entryAction) {\n' +
                '                                case \'new\':\n' +
                '                                    if (instrument = mdeHash[entryType + \'_\' + action[\'MDReqID\'] + \'_\' + entry[\'MDEntryID\']]) {\n' +
                '\n' +
                '                                        /** Case 1: new item, exist  in cache, replace it */\n' +
                '                                        if (entry[\'MDEntryPx\'] && entry[\'MDEntrySize\']) {\n' +
                '                                            mdeHash[entryType + \'_\' + action[\'MDReqID\'] + \'_\' + entry[\'MDEntryID\']][\'MDEntryPx\'] = entry[\'MDEntryPx\'];\n' +
                '                                            mdeHash[entryType + \'_\' + action[\'MDReqID\'] + \'_\' + entry[\'MDEntryID\']][\'MDEntrySize\'] = entry[\'MDEntrySize\'];\n' +
                '                                            mdeHash[entryType + \'_\' + action[\'MDReqID\'] + \'_\' + entry[\'MDEntryID\']][\'SendingTime\'] = action[\'SendingTime\'];\n' +
                '\n' +
                '                                            that.mde[entryType][action[\'MDReqID\']].forEach(function (val, key, arr) {\n' +
                '                                                if(val[\'MDEntryID\'] === entry[\'MDEntryID\'] &&\n' +
                '                                                    val[\'MDEntryType\'] === entry[\'MDEntryType\']) {\n' +
                '                                                    arr[key][\'MDEntryPx\'] = entry[\'MDEntryPx\'];\n' +
                '                                                    arr[key][\'MDEntrySize\'] = entry[\'MDEntrySize\'];\n' +
                '                                                    arr[key][\'createdAt\'] = action[\'SendingTime\'];\n' +
                '                                                }\n' +
                '                                            });\n' +
                '\n' +
                '                                            that.mde[entryType][action[\'MDReqID\']][\'MaturityDate\'] = action[\'MaturityDate\'];\n' +
                '                                            that.mde[entryType][action[\'MDReqID\']][\'CouponRate\'] = action[\'CouponRate\'];\n' +
                '                                        }\n' +
                '                                    } else {\n' +
                '                                        /** Case 2: newSecurityID item, not exists in cache, add it to global instuments obj and cache */\n' +
                '                                        if(!that.mde[entryType]) {\n' +
                '                                            that.mde[entryType] = {}\n' +
                '                                        }\n' +
                '                                        if (!that.mde[entryType][action[\'MDReqID\']]) {\n' +
                '                                            that.mde[entryType][action[\'MDReqID\']] = []\n' +
                '                                        }\n' +
                '                                        that.mde[entryType][action[\'MDReqID\']].push(entry);\n' +
                '                                        /** Add to cache */\n' +
                '                                        mdeHash[entryType + \'_\' + action[\'MDReqID\'] + \'_\' + entry[\'MDEntryID\']] = entry;\n' +
                '                                    }\n' +
                '                                    break;\n' +
                '                                case \'delete\':\n' +
                '                                    /** Case 3: remove item */\n' +
                '                                    if (instrument = mdeHash[entryType + \'_\' + action[\'MDReqID\'] + \'_\' + entry[\'MDEntryID\']]) {\n' +
                '                                        let period = that.mde[entryType][action[\'MDReqID\']];\n' +
                '                                        if (!period || !period.indexOf) {\n' +
                '                                            return\n' +
                '                                        }\n' +
                '                                        let index = period.indexOf(instrument);\n' +
                '                                        if (index !== -1) {\n' +
                '                                            /** Removing from main store */\n' +
                '                                            period.splice(index, 1);\n' +
                '                                        }\n' +
                '                                        /** Removing from cache */\n' +
                '                                        delete mdeHash[entryType + \'_\' + action[\'MDReqID\'] + \'_\' + entry[\'MDEntryID\']];\n' +
                '                                    } else {\n' +
                '\n' +
                '                                    }\n' +
                '                                    break;\n' +
                '                            }\n' +
                '                        });\n' +
                '                    });\n' +
                '                    /**\n' +
                '                     * Productivity increase\n' +
                '                     */\n' +
                '                    if (!that.refreshInterval) {\n' +
                '                        that.refreshInterval = setInterval(function() {\n' +
                '                            that.sortTablesByType();\n' +
                '                            that.combineTablesForOrders();\n' +
                '                            that.renderDataTest(that.mdeTable);\n' +
                '                        }, 300)\n' +
                '                    }\n' +
                '\n' +
                '                    that.lastUpdate(lastUpdateTime);\n' +
                '                });\n' +
                '\n' +
                '                // this.fxSocket.on(\'lastUpdateTime\', function(time) {\n' +
                '                //     that.lastUpdate(time);\n' +
                '                // });\n' +
                '\n' +
                '                this.fxSocket.on(\'data\', data => {\n' +
                '                    this.securityListSpreads = data[\'OTR/OTR/A\'];\n' +
                '                });\n' +
                '            },\n' +
                '            getTitleFromReqId: function(title) {\n' +
                '                if(!title) {\n' +
                '                    return null;\n' +
                '                }\n' +
                '                let keys = title.split(\'_\');\n' +
                '                return keys[1] + \'-\' + keys[0];\n' +
                '            },\n' +
                '            getTitleFromReqIdTop: function(title) {\n' +
                '                if(!title) {\n' +
                '                    return null;\n' +
                '                }\n' +
                '                let keys = title.split(\'_\');\n' +
                '                if (keys[1] === \'OLD\') {\n' +
                '                    return keys[0] + \'O\';\n' +
                '                }\n' +
                '                return keys[0] + \'C\';\n' +
                '            },\n' +
                '            getTitleFromOLDKey: function(title) {\n' +
                '                if(!title) {\n' +
                '                    return null;\n' +
                '                }\n' +
                '                let keys = title.split(\'_\');\n' +
                '                return \'OTR-\' + keys[0];\n' +
                '            },\n' +
                '            getTitleFromSpreadKey: function(title) {\n' +
                '                if (!title) {\n' +
                '                    return null;\n' +
                '                }\n' +
                '                let keys = title.split(\'_\');\n' +
                '                let keyNum = keys[0].split(\'/\');\n' +
                '                let keyType = keys[1].split(\'/\');\n' +
                '                try {\n' +
                '                    return keyType[0] + \'-\' + keyNum[0] + \' / \' + keyType[1] + \'-\' + keyNum[1]\n' +
                '                }catch (e) {\n' +
                '\n' +
                '                }\n' +
                '\n' +
                '            },\n' +
                '            /**\n' +
                '             * Calculating last update time, since last adding order from server\n' +
                '             **/\n' +
                '            lastUpdate: function(time) {\n' +
                '                if (!time) {\n' +
                '                    return null;\n' +
                '                }\n' +
                '                if (!window.moment) {\n' +
                '                    return time;\n' +
                '                }\n' +
                '                this.lastUpdated = moment(time).tz(\'America/New_York\').format("MM-DD-YYYY HH:mm:ss");\n' +
                '            },\n' +
                '            /**\n' +
                '             * Grouping off-the-run specific data by symbol+symbolSfx for rendering in tables\n' +
                '             * @param mdeTable\n' +
                '             * @param offTheRunData\n' +
                '             */\n' +
                '            groupOffTheRunData: function(offTheRunData, mdeTable) {\n' +
                '                let resultGrouping = {};\n' +
                '                offTheRunData.forEach(function (row) {\n' +
                '                    if (row.SymbolSfx !== \'OLD\') {\n' +
                '                        return;\n' +
                '                    }\n' +
                '                    let dataKey = row[\'Symbol\'] + \'_OLD_\' + row[\'Product\'] + \'_\' + row[\'SecurityType\'];\n' +
                '                    if (!resultGrouping[dataKey]) {\n' +
                '                        let otrMde = mdeTable[dataKey];\n' +
                '                        if (otrMde && Object.keys(otrMde).length) {\n' +
                '                            let sortedEntries = _.orderBy(otrMde, [\'createdAt\'], [\'desc\']);\n' +
                '                            sortedEntries = sortedEntries.slice(0,3).reverse();\n' +
                '                            resultGrouping[dataKey] = sortedEntries.map(function(val) { //debugger\n' +
                '                                val[\'MaturityDate\'] = row[\'MaturityDate\'];\n' +
                '                                val[\'CouponRate\'] = row[\'CouponRate\'];\n' +
                '                                return val;\n' +
                '                            });\n' +
                '                        }\n' +
                '                    }\n' +
                '                });\n' +
                '\n' +
                '                return resultGrouping;\n' +
                '            },\n' +
                '\n' +
                '            groupSpreadData: function(spreadData) { //debugger\n' +
                '                spreadData = spreadData.map(function(val) {\n' +
                '                    let resultSpread = {};\n' +
                '                    try {\n' +
                '                        resultSpread.title = val.legs[0][\'LegSymbolSfx\'] + \'-\' + val.legs[0][\'LegSymbol\'] + \'/\';\n' +
                '                        resultSpread.title += val.legs[1][\'LegSymbolSfx\'] + \'-\' + val.legs[1][\'LegSymbol\'];\n' +
                '                        resultSpread.bidQuantity = val.legs[0][\'LegRatioQty\'];\n' +
                '                        resultSpread.bidPrice = val.legs[0][\'LegCouponRate\'];\n' +
                '                        resultSpread.offerQuantity = val.legs[1][\'LegRatioQty\'];\n' +
                '                        resultSpread.offerPrice = val.legs[1][\'LegCouponRate\'];\n' +
                '                    }catch (e) {\n' +
                '                        console.log(e);\n' +
                '                        return;\n' +
                '                    }\n' +
                '\n' +
                '                    return resultSpread;\n' +
                '                });\n' +
                '\n' +
                '                return spreadData;\n' +
                '            },\n' +
                '            groupSpreadDataTest: function(spreadData) { //debugger\n' +
                '                spreadData = spreadData.map(function(val) {\n' +
                '                    let resultSpread = {};\n' +
                '                    try {\n' +
                '                        resultSpread.title = val.legs[0][\'LegSymbolSfx\'] + \'-\' + val.legs[0][\'LegSymbol\'] + \' / \';\n' +
                '                        resultSpread.title += val.legs[1][\'LegSymbolSfx\'] + \'-\' + val.legs[1][\'LegSymbol\'] + \' / A\';\n' +
                '                        resultSpread.anchorLeg = val.legs[0][\'LegSymbolSfx\'] + \'-\' + val.legs[0][\'LegSymbol\'];\n' +
                '                        resultSpread.anchorLegWeight = val.legs[0][\'LegRatioQty\'];\n' +
                '                        resultSpread.calculatedLeg = val.legs[1][\'LegSymbolSfx\'] + \'-\' + val.legs[1][\'LegSymbol\'];\n' +
                '                        resultSpread.calculatedLegWeigh = val.legs[1][\'LegRatioQty\'];\n' +
                '                    }catch (e) {\n' +
                '                        console.log(e);\n' +
                '                        return null;\n' +
                '                    }\n' +
                '\n' +
                '                    return resultSpread;\n' +
                '                });\n' +
                '\n' +
                '                return spreadData;\n' +
                '            },\n' +
                '            /**\n' +
                '             * return order item spread type\n' +
                '             * @param spreadName\n' +
                '             * @return {string|null}\n' +
                '             */\n' +
                '            getItemType: function(spreadName) {\n' +
                '                if (!spreadName) {\n' +
                '                    return null;\n' +
                '                }\n' +
                '                if (spreadName === this.filterValues.otr) {\n' +
                '                    return this.filterValues.otr\n' +
                '                } else if(spreadName.match(this.filterValues.old) && !spreadName.match(\'/\')) {\n' +
                '                    return this.filterValues.old;\n' +
                '                } else if(!spreadName.match(\'WI\') && spreadName.match(\'/\')) {//todo\n' +
                '                    return this.filterValues.spread;\n' +
                '                }\n' +
                '            },\n' +
                '            /**\n' +
                '             * From basic full format - to DD-MM-YYYY\n' +
                '             * @param date\n' +
                '             * @return {null|string}\n' +
                '             */\n' +
                '            convertMaturityDate: function(date) {\n' +
                '                if (!date) {\n' +
                '                    return null;\n' +
                '                }\n' +
                '                return moment(date).format(\'MM-DD-YY\');\n' +
                '            },\n' +
                '            convertDate: function(date) {\n' +
                '                if (!date) {\n' +
                '                    return null;\n' +
                '                }\n' +
                '                //debugger\n' +
                '                return moment.utc(date, \'YYYYMMDD-HH:mm:ss.SSS\').tz(\'America/New_York\').tz(\'America/New_York\').format("MM-DD-YYYY HH:mm:ss")\n' +
                '                //debugger\n' +
                '                // return moment(moment().toISOString(date)).tz(\'America/New_York\').format("MM-DD-YYYY HH:mm:ss")\n' +
                '                //return moment(date).tz(\'America/New_York\').format("MM-DD-YYYY HH:mm:ss");\n' +
                '            },\n' +
                '            processPrice: function(price) {\n' +
                '                if (!price) {\n' +
                '                    return \'\';\n' +
                '                }\n' +
                '                let fraction = Math.abs(price) % 1;\n' +
                '                if (fraction === 0) {\n' +
                '                    return Math.trunc(price) + \'-00\';\n' +
                '                }\n' +
                '\n' +
                '                let fraction32 = fraction * 32;\n' +
                '                let fraction32Trunced = Math.trunc(fraction32);\n' +
                '                let addingInt = \'-\';\n' +
                '                if (fraction32Trunced >= 1 && fraction32Trunced < 10) {\n' +
                '                    addingInt += \'0\' + fraction32Trunced;\n' +
                '                } else if(fraction32Trunced === 0) {\n' +
                '                    addingInt += \'00\';\n' +
                '                } else {\n' +
                '                    addingInt += fraction32Trunced;\n' +
                '                }\n' +
                '\n' +
                '                fraction = fraction32 % 1;\n' +
                '                fraction = Math.round(fraction * 8);\n' +
                '                //return Math.trunc(price) + addingInt + (fraction === 5 ? \'+\' : fraction) + ` (${fraction32})`;\n' +
                '                let string =  Math.trunc(price) + addingInt + (fraction === 4 ? \'+\' : fraction);\n' +
                '                // string += `<br/><small>(${price})</small>`;\n' +
                '                return string;\n' +
                '            },\n' +
                '            processPrice16: function(price) {\n' +
                '                if (!price) {\n' +
                '                    return \'\';\n' +
                '                }\n' +
                '                let fraction = Math.abs(price) % 1;\n' +
                '                if (fraction === 0) {\n' +
                '                    return Math.trunc(price) + \'-00\';\n' +
                '                }\n' +
                '\n' +
                '                let fraction32 = fraction * 32;\n' +
                '                let fraction32Trunced = Math.trunc(fraction32);\n' +
                '                let addingInt = \'-\';\n' +
                '                if (fraction32Trunced >= 1 && fraction32Trunced < 10) {\n' +
                '                    addingInt += \'0\' + fraction32Trunced;\n' +
                '                } else if(fraction32Trunced === 0) {\n' +
                '                    addingInt += \'00\';\n' +
                '                } else {\n' +
                '                    addingInt += fraction32Trunced;\n' +
                '                }\n' +
                '\n' +
                '                let fraction16 = Math.trunc(fraction32 % 1 * 16);\n' +
                '                if (fraction16 === 0) {\n' +
                '                    return Math.trunc(price) + addingInt;\n' +
                '                }\n' +
                '                return  Math.trunc(price) + addingInt + (fraction16 === 8 ? \'+\' : fraction16 / 2);\n' +
                '            },\n' +
                '            processQuantity: function(quantity, hideMillon) {\n' +
                '                if(quantity) {\n' +
                '                    let result = quantity / 1000000;\n' +
                '                    if (!hideMillon) {\n' +
                '                        result = result + \'m\'\n' +
                '                    }\n' +
                '                    //return quantity / 1000000  + \'M\';\n' +
                '                    return result;\n' +
                '                }\n' +
                '            },\n' +
                '            bannedPeriod: function(period) {\n' +
                '                return period[\'Symbol\'] === \'1M\'\n' +
                '                    || period[\'Symbol\'] === \'3M\'\n' +
                '                    || period[\'Symbol\'] === \'6M\'\n' +
                '                    || period[\'Symbol\'] === \'1Y\';\n' +
                '            },\n' +
                '            filterAndSortOtrOld: function(data) {\n' +
                '                let that = this;\n' +
                '                return data.filter(function(val) {\n' +
                '                    return !that.bannedPeriod(val);\n' +
                '                }).sort(that.sortingParers);\n' +
                '            },\n' +
                '            filterAndSortSpread: function(spreadData) {\n' +
                '                let that = this;\n' +
                '                spreadData = spreadData.filter(function(val) {\n' +
                '                    return !val[\'SymbolSfx\'].match(\'OLD\');\n' +
                '                }).sort(that.sortingParers);\n' +
                '\n' +
                '                return spreadData;\n' +
                '            },\n' +
                '            sortingParers: function(el1, el2) {\n' +
                '                let periodA = el1[\'Symbol\'].match(/\\d+/)[0];\n' +
                '                let periodB = el2[\'Symbol\'].match(/\\d+/)[0];\n' +
                '                return periodA - periodB;\n' +
                '            },\n' +
                '            getSpreadCalculation: function(paper) {\n' +
                '                if (!paper) {\n' +
                '                    return\n' +
                '                }\n' +
                '                const period = paper.period.split(\'_\');\n' +
                '                let lastTopOfBook = this.lastOtrForOld[period[1] + \'-\' + period[0]];\n' +
                '                let diffPrice;\n' +
                '                if (lastTopOfBook) {\n' +
                '                    diffPrice = lastTopOfBook.bid[\'MDEntryPx\'] - lastTopOfBook.offer[\'MDEntryPx\'];\n' +
                '                    return this.processPrice16(diffPrice) || \'0\';\n' +
                '                }\n' +
                '                if (period[1] === \'OLD\') {\n' +
                '                    diffPrice = paper.refresh.bidPrice - paper.refresh.offerPrice;\n' +
                '                    return this.processPrice16(diffPrice) || \'0\';\n' +
                '                }\n' +
                '                return \'0\';\n' +
                '            },\n' +
                '            setFilter: function(filterValue) {\n' +
                '                if (filterValue) {\n' +
                '                    this.filter = filterValue;\n' +
                '                } else {\n' +
                '                    console.log(\'Filter value is not provided\');\n' +
                '                }\n' +
                '            }\n' +
                '        },\n' +
                '        mounted: function () {\n' +
                '            /** Init socket and create connection */\n' +
                '            // this.fxSocket = io(window.fixHost === \'$HOST\' ? \'http://209.97.148.112:8080\' : window.fixHost);\n' +
                '            // this.fxSocket = io(\'http://209.97.148.112:8080\');\n' +
                '            this.fxSocket = io(\'https://marketaxess.liquidityedge.trade/\',{\n' +
                '                transports: [\'websocket\']\n' +
                '            });\n' +
                '\n' +
                '            // on reconnection, reset the transports option, as the Websocket\n' +
                '// connection may have failed (caused by proxy, firewall, browser, ...)\n' +
                '            this.fxSocket.on(\'reconnect_attempt\', () => {\n' +
                '                this.fxSocket.io.opts.transports = [\'polling\', \'websocket\'];\n' +
                '            });\n' +
                '            this.socketEvents();\n' +
                '\n' +
                '            /** Init filter default value */\n' +
                '            this.filter = this.filterValues.tom;\n' +
                '        }\n' +
                '    });\n' +
                '</script>\n');
            this.setState({scriptsLoaded: true})
        }
    };

    render() {
        return (
            <div id="bookviewerFeedApp" style={{marginTop: '60px', marginBottom: '60px'}}><div dangerouslySetInnerHTML={{__html: Page}}/></div>
        );
    }
}

export default BookviewerFeed;



// WEBPACK FOOTER //
// ./frontend/components/BookviewerFeed/BookviewerFeed.jsx